module.exports = __webpack_public_path__ + "img/07.947a4c4c.png";